// extracted by mini-css-extract-plugin
export default {"section":"RankSection_section__et7pY","section_title":"RankSection_section_title__oi5gI","rank":"RankSection_rank__grOBQ"};